define((require) => {
    "use strict";

    const $                   = require("jquery");
    const EventDispatcher     = require("shared/util/EventDispatcher");
    const EditorEvents        = require("shared/services/EditorEvents");
    const Tip                 = require("ui/common/tip/Tip");

    /**
     * Tracks user activity and shows tips to suggest when a user could do something differently.
     *
     * @author Bruce Mackenzie Nielsen
     * @class TipManager
     * @constructor
     */
    return EventDispatcher.extend({

        _currentTip: null,

        _events: {},

        /**
         * Map of editor events to their tip handler.
         *
         * <p>For convenience, the tip handler is passed the array of timestamps corresponding to occurrences of the
         * event type. You can look up occurrences of other events by looking at this._events.</p>
         */
        handlers: {
            "imageWidgetProperties:uploadButton:click": function(events) {
                // Show a tip if the user does it three times
                if (events.length === 3) {
                    this._showTip(new Tip({content: require("ui/common/tip/ImageUploadTip.tpl")}));
                }
            }
        },

        constructor() {
            this.listenTo(EditorEvents, "all", this._eventHandler);
        },

        _eventHandler(event) {
            // Push the event into the map
            const eventArray = this._events[event] || [];
            eventArray.push(Date.now());
            this._events[event] = eventArray;

            // Invoke the handler for this type of event
            if (this.handlers[event]) {
                this.handlers[event].bind(this)(eventArray);
            }
        },

        _showTip(tip) {
            if (this._currentTip) {
                this._currentTip.$el.remove();
            }

            this._currentTip = tip;
            tip.render();
            $("body").append(tip.$el);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/services/TipManager.js